/**
 * @typedef {object} Point
 * @property {number} lng - The longitude
 * @property {number} lat - The latitude
 */

/**
 * A set of points
 * @typedef {Point[]} Polygon
 */

/**
 * A function that takes a point and a set of polygons.
 * If a third parameter `index` was given as a number, it checks whether that point lies inside the polygon with that index.
 * If that parameter wan't given, it checks whether the point lies inside any of the polygons
 *
 * You may have noticed that the third parameter can be dropped altogether and the other function below used for the same purpose instead. That is true and might happen in the future.
 *
 * @param {Point} point
 * @param {Polygon[]} polygons
 * @param {number} index
 * @returns {boolean}
 */

export const isPointInPolygon = (point, polygons, index) => {
  if (typeof index === "number") {
    return isPointInSinglePolygon(point, polygons[index]);
  }
  return polygons.some((poly) => isPointInSinglePolygon(point, poly));
};

/**
 * A function that checks whether a point lies inside a polygon
 *
 * @param {Point} point
 * @param {Polygon} polygon
 * @returns {boolean}
 */

export const isPointInSinglePolygon = (point, polygon) => {
  const { lat, lng } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat,
      yi = polygon[i].lng;
    const xj = polygon[j].lat,
      yj = polygon[j].lng;

    const intersect =
      yi > lng !== yj > lng && lat < ((xj - xi) * (lng - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};
